import React, { useEffect, useRef, useState } from 'react';
import ReportDrawer from '../../../constants/ReportDrawer';
import SidebarOpen from '../../../constants/SidebarOpen';
import TranRptFormView from '../../../components/account/reports/tran_rpt/TranRptFormView';
import { useSidebar } from '../../../helpers/sidebarClose';
import TranRptListView from '../../../components/account/reports/tran_rpt/TranRptListView';
import CircleBtn from '../../../constants/CircleBtn';
import ReportHeader from '../../../constants/ReportHeader';
import { useReactToPrint } from "react-to-print";
import PrintTransReportView from '../../../components/account/reports/tran_rpt/PrintTransReportView';
import { TransactionRpt } from '../../../helpers/models/Models';

const TransactionReportCreateListView = ({ setIconsButton }: { setIconsButton: any }) => {
    const { isOpen, toggleSidebar, closeSidebar } = useSidebar('sidebar1');
    const [onTransReport, setOnTransReport] = useState<TransactionRpt[]>([]);
    const componentListRef = useRef<HTMLDivElement | null>(null);

    const handlePrintCard = useReactToPrint({
        content: () => componentListRef.current!,
    });

    useEffect(() => {
        setIconsButton(<CircleBtn onClick={handlePrintCard} />);
        return () => setIconsButton(null);
    }, []);

    useEffect(() => {
        if (!isOpen) {
            toggleSidebar();
        }
    }, [isOpen, toggleSidebar]); 
    return (
        <>
            <SidebarOpen onClick={toggleSidebar} />
            <ReportDrawer header={<ReportHeader label='Transaction Report' />} open={isOpen} onClose={closeSidebar}>
                <TranRptFormView setOnTransReport={setOnTransReport} />
            </ReportDrawer>
            <TranRptListView onTransReport={onTransReport} />
            <div className='hidden'>
                <div ref={componentListRef}>
                    <PrintTransReportView onTransReport={onTransReport} />
                </div>
            </div>
        </>
    );
}

export default TransactionReportCreateListView;
